module.exports = __webpack_public_path__ + "static/media/services2.f1f221f2.png";